import { AbsoluteResolvedModelPath, createAbsoluteFromMask, PathTokens } from "../../../../Common/ModelPath/ModelPath";
import { MatchKind, PathMatcher } from "../../../../Common/ModelPath/PathMatcher";
import { FormSettings } from "../../Forms/Types/FormSettings";
import { CandyDispatch } from "../Core/Store/CandyReduxTypes";

export const externalOnClickHandler = (dispatch: CandyDispatch, bindingPath: AbsoluteResolvedModelPath) =>
    dispatch(async (_, __, form) => {
        const nlContract = form.settings?.externalOnClickByPathWithSingleCallback;
        if (nlContract) {
            const isSuitableToClick = checkIsSuitableToClick(form.settings, bindingPath);
            if (isSuitableToClick) {
                const onCLickHandler = form.settings.externalOnClickByPathWithSingleCallback?.callback;
                await onCLickHandler?.(bindingPath.toLegacyPath());
            }
        }
    });

export const checkIsSuitableToClick = (formSetting: FormSettings, bindingPath: AbsoluteResolvedModelPath): boolean =>
    (formSetting.externalOnClickByPathWithSingleCallback?.pathMasks ?? []).some(path =>
        PathMatcher.match(
            createAbsoluteFromMask(path, PathTokens.each).getPathPartsAsArray(),
            bindingPath.getPathPartsAsArray()
        ).every(match => match.kind !== MatchKind.DifferentSuffix)
    );
